import { img6 } from "../../_components/Imagepath";

export default {
    Data: [
        {
            id:1,  
            key:5,
            Invoice: "#4991",
            Category: "Software",
            Created : "12 May 2022",
            Name: "Pricilla",
            email: "pricilla@example.com",
            img:img6,
            Total: "$5,54,220",
            Paid: "$3,50,000",
            Payment: "Cheque",
            Balance: "$4,220",
            Due: "18 May 2023",
            Status: "UnPaid",
            Action: ""
          },
    ]
}